import { render, staticRenderFns } from "./Phrases.vue?vue&type=template&id=5fde248f&scoped=true&"
import script from "./Phrases.vue?vue&type=script&lang=js&"
export * from "./Phrases.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/phrases.css?vue&type=style&index=0&id=5fde248f&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/sp/phrases.css?vue&type=style&index=1&id=5fde248f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fde248f",
  null
  
)

export default component.exports